import { FeatureToggleServiceConfig } from 'feature-toggle-service';

export const featureTogglesConfig: FeatureToggleServiceConfig = {
  // Format:
  // // [JIRA_TICKET_ID] [DESCRIPTION]
  // [FEATURE_NAME]: false | true,

  // WO 22907014 [AD ] Account Hierarchy needs to be activated in production
  FMPOModuleAccessGuard: true,

  dashboardDownloadCsv: true,

  // WO 22907014 [AD ] Account Hierarchy needs to be activated in production
  accHierarchyLoyaltyEnabled: true,
  AccHierarchyStoresEnabled: true,

  //Enable the cruise portal segments
  INV_CRUISE_PORTAL_A: false,

  // Added for Edenred & AD suppport flow (FRONTO-12360)
  PLUSME_CUS_SUPPORT_A: true,

  // ETE-726 Agency Wishlist update post order confirmation
  AMADEUS_DIRECT_WISHLIST_A: true,

  // ETE-967 Improve display of list of monthly invoices
  AMADEUS_DIRECT_INVOICES_A: false,

  //ETE-2710 removing the right side part of the contact page
  AD_CONTACTUS_NEW_CHANGES_E: true,

  // ETE-2694 As a +Me member on AD , i want to have a
  // visibility of my expired points To be included in points balance page and home page tile
  AD_POINT_BALANCE_BANNER_E: true,

  // FRONTO-31060 Enhance logic for currency mapping
  AVC_TA_CURRENCY: true,

  INVOCING_NETWORK_LEVEL_A: true,

  DASHBOARD_WARNING_MESSAGE_A: true,

  AD_AVC_BOOKING_IMPROVEMENT_A: true,

  AD_AVC_DASHBOARD_NEW_HIERARCHY: true,

  AD_AVC_CREDIT_LINE_S3J_A: true
};
